import { AppBar, Toolbar, Button, Typography } from '@mui/material';
import Logo from './Logo';
import { Link } from 'react-router-dom';
import SignModal from './SignModal';
import { useUser } from '../../contexts/UserContext';
import CartIconButton from '../cart/CartIconButton';
import { useAuth } from '../../contexts/AuthContext';
import { usePublicSettings } from '../../hooks/usePublicSettings';
import useSettings from '../../hooks/useSettings';

const NavigationBar = () => {
    const { user } = useUser();
    const { handleLoginClick, logoutUser } = useAuth();
    const { companyName } = usePublicSettings();
    const { backgroundColor, textColor } = useSettings();

    return (
        <AppBar position="static" className="py-2 menu" sx={{backgroundColor: backgroundColor+' !important', color: textColor+' !important'}}>
            <Toolbar>
                <Link to="/"><Logo /></Link>
                {companyName && <div className="ml-5 hide-mobile"><Typography className='fw-500' variant="h6">{companyName}</Typography></div>}
                <div className="ml-auto">
                    {!user && (
                        <>
                            <Button color="inherit"><Link to="/signup">Sign Up</Link></Button>
                            <Button color="inherit" onClick={handleLoginClick} className="fs-16">Login</Button>
                        </>
                    )}
                    {user && (
                        <>
                            <CartIconButton />
                            <Button color="inherit"><Link to="/signin">My Profile</Link></Button>
                            <Button color="inherit" onClick={logoutUser} className="fs-16">Logout</Button>
                        </>
                    )}
                </div>
            </Toolbar>

            <SignModal />
        </AppBar>
    );
};

export default NavigationBar;
